import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './TauriNavigation.css';
import TauriUserView from '../TauriUserView/TauriUserView';
import TauriSearchBox from '../TauriSearchBox/TauriSearchBox';
import TauriBrand from '../TauriBrand/TauriBrand';
import config from '../../config.json';
import { AccessComponentFactory } from '../../visualizations/AccessComponentFactory';

const TauriNavigation = () => {
  const [userViewData, setUserViewData] = useState([]);
  const [brandNameData, setBrandNameData] = useState([]);
  const [userLevel, setUserLevel] = useState(-1);

  const accessLevels = [
    { level: 2, roleName: 'District Sales Manager' },
    { level: 1, roleName: 'Medical Representative' },
    { level: 4, roleName: 'Regional Manager' },
    { level: 3, roleName: 'Distributor Manager' },
    { level: 5, roleName: 'National Sales Manager' },
  ];

  useEffect(() => {
    // Get user data from localStorage
    const getUserData = localStorage.getItem('UserData');
    const decodedUserData = JSON.parse(atob(getUserData));
    const user = decodedUserData?.UserInfo?.Data;

    const getPermission = localStorage.getItem('permission');
    const decodedPermission = JSON.parse(atob(getPermission));

    const access = decodedPermission?.DataScope?.Access;

    const userPermission = decodedUserData?.UserPermission?.Data;
    const firstname = user.FirstName || '';
    const lastname = user.LastName || '';

    const designation = user.Designation || '';
    // Extract the access level for the first filtered item (if any)
    const userAccessLevel = access || '-1';
    const role = accessLevels.find(item => item.level === userAccessLevel)?.roleName;

    const userInfo = { firstname, lastname, role: designation ? designation : role };
    setUserViewData(userInfo);
    setUserLevel(userAccessLevel);

    // Get roles and brand data
    const brandData = AccessComponentFactory('brand', userAccessLevel.toString());
    setBrandNameData(brandData);
  }, []);

  return (
    <header className="navbar sticky-top flex-lg-nowrap p-0">
      <button
        className="navbar-toggler ms-2 d-lg-none collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#sidebarMenu"
        aria-controls="sidebarMenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <img src={process.env.PUBLIC_URL + "/Images/hamburger-white.svg"} className='navbar-toggler-icon' />
      </button>
      <TauriBrand brandname={brandNameData?.brandName} />

      <div className="nav-item d-lg-none">
        <div className="nav-item text-nowrap">
          <TauriUserView firstName={userViewData.firstname} lastName={userViewData.lastname} position={userViewData.role} />
        </div>
      </div>


      {userLevel === 5 &&
        <div className='section-search w-100'>
          <TauriSearchBox />
        </div>
      }

      <div className="navbar-nav d-none d-lg-flex">
        <div className="nav-item text-nowrap">
          <TauriUserView firstName={userViewData.firstname} lastName={userViewData.lastname} position={userViewData.role} />
        </div>
      </div>
    </header>
  );
};

export default TauriNavigation;